import React from 'react';
import './group-metric-card.scss';

export interface GroupMetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  className?: string;
}

// CDMX-15947 — a right-sidebar metric card for the coder "My Work" view
// (Cases on Hold / Escalated Cases / Completed Today). Title above a large
// value, with a muted descriptive subtitle.
export const GroupMetricCard: React.FC<GroupMetricCardProps> = ({
  title,
  value,
  subtitle,
  className = ''
}) => {
  return (
    <div
      className={`cmx-group-metric-card ${className}`.trim()}
      data-testid="group-metric-card">
      <span className="cmx-group-metric-card__title">{title}</span>
      <span
        className="cmx-group-metric-card__value"
        data-testid="group-metric-card-value">
        {value}
      </span>
      {subtitle !== undefined && (
        <span className="cmx-group-metric-card__subtitle">{subtitle}</span>
      )}
    </div>
  );
};

GroupMetricCard.displayName = 'GroupMetricCard';
export default GroupMetricCard;
